import { useQuery } from '@apollo/client'

import { GetSessionUserDocument } from '@/graphql/purchase-plus/generated/getSessionUser.generated'
import { UserAccessControlList } from '@/modules/access/types'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import isPublicRoutes from '@/modules/shared/utils/isPublicRoutes'

interface UseSessionUser {
  skip?: boolean
}

export default function useSessionUser(args?: UseSessionUser) {
  const { skip = false } = args || {}
  const { data, loading, error, refetch } = useQuery(GetSessionUserDocument, {
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
    skip: skip || isPublicRoutes(),
  })

  const currentOrganisation = data?.currentOrganisationUnit
  const currentOrganisationPurchaser = currentOrganisation?.__typename === 'Purchaser' ? currentOrganisation : null
  const currentOrganisationSupplier = currentOrganisation?.__typename === 'Supplier' ? currentOrganisation : null

  const currentLegalEntity = data?.currentLegalEntity
  const currentLegalEntityPurchaser = currentLegalEntity?.__typename === 'Purchaser' ? currentLegalEntity : null
  const currentLegalEntitySupplier = currentLegalEntity?.__typename === 'Supplier' ? currentLegalEntity : null

  return {
    user: data?.currentUser,
    userPermissions: data?.currentUser?.accessControlList as UserAccessControlList,
    currentOrganisation,
    currentOrganisationPurchaser,
    currentOrganisationSupplier,
    currentLegalEntity,
    currentLegalEntityPurchaser,
    currentLegalEntitySupplier,
    currentAccountsPayableSystem: data?.currentAccountsPayableSystem,
    currentHolder: data?.currentHolder,
    appVersion: { be: data?.backendVersion, fe: import.meta.env.VITE_APP_VERSION },
    loading,
    error,
    refetch,
  }
}
